import LoadingColors from './LoadingColors'

export default LoadingColors
